<template>
  <div>
    <!-- <h1>manage_elements</h1> -->
    <section v-if="!isAdvancedMode">
      <p>Vous pouvez modifier un élément.</p>
      <p>Vous pouvez corriger une faute de frappe concernant un élément.</p>
    </section>
    <section v-else>
      <p>Vous pouvez personnaliser la représentation automatisée des éléments dans le langage <a href="https://www.swi-prolog.org">PROLOG</a> en cliquant sur l'élément après avoir choisi le mode PROLOG.</p>
      <p>Vous supprimez la représentation actuelle en cliquant sur x, puis vous commencez à élaborer votre propre représentation.</p>
      <p>Une case de données d'entrée cochée signifie que ces données doivent être fournies par l'utilisateur. Si vous n'êtes pas d'accord, décochez.</p>
      <p>Vous commencez à élaborer votre propre représentation et chaque fois que vous tapez une virgule, puis que vous commencez à taper un nouveau texte, vous voyez des cases apparaître à remplir.</p>
      <p>Chaque case correspond à un sous-élément de l'élément initial écrit en langage naturel. Dans la case <pre>Description en language naturel</pre>, vous pouvez écrire une représentation en langage naturel. Si c'est une donnée d'entrée, c'est le texte que l'utilisateur verra.</p>
      <p>Pour chaque case, vous décidez si c'est une donnée d'entrée en cochant.</p>
      <p>Chaque sous-élément apparaîtra dans la liste des éléments.</p>
    </section>
  </div>
</template>
<script>
export default {
  computed: {
    isAdvancedMode () {
      return this.$store.state.mode === 'advanced'
    },
  },
}
</script>